import { handleActions } from 'redux-actions'
import {
  UPDATE_EMAIL_CONTACT_START,
  UPDATE_EMAIL_CONTACT_SUCCESS,
  UPDATE_EMAIL_CONTACT_ERROR,
  UPDATE_EMAIL_CONTACT_FINALLY,
  CHANGE_STATUS_FALSE,
  GET_KC_USER_START,
  GET_KC_USER_SUCCESS,
  GET_KC_USER_ERROR,
  GET_KC_USER_FINALLY,
  SET_KC_USER,
  CHANGE_EMAIL_SSO_START,
  CHANGE_EMAIL_SSO_SUCCESS,
  CHANGE_EMAIL_SSO_ERROR,
  CHANGE_EMAIL_SSO_FINALLY,
  CLEAR_EMAIL_SSO_ERROR,
  SET_EMAIL_MODAL_STATUS
} from '../../redux/actions'

const initialState = {
  data: {},
  error: null,
  isLoading: false,
  status: null,
  kcUser: null,
  kcLoading: false,
  kcError: null,
  kcUserExists: false,
  kcUserHasSubscription: false,
  changeEmailSsoLoading: false,
  changeEmailSsoError: null,
  changeEmailSsoStatus: null,
  emailModalStatus: "editing",
}

export default handleActions({
  [UPDATE_EMAIL_CONTACT_START]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [UPDATE_EMAIL_CONTACT_SUCCESS]: (state, action) => ({
    ...state,
    data: action.payload,
    status: action.payload.status
  }),
  [UPDATE_EMAIL_CONTACT_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,
    status: false,
  }),
  [UPDATE_EMAIL_CONTACT_FINALLY]: state => ({
    ...state,
    isLoading: false
  }),
  [CHANGE_STATUS_FALSE]: state => ({
    ...state,
    data: {},
    error: null,
    isLoading: false,
    status: null,
  }),
  [GET_KC_USER_START]: (state) => ({
    ...state,
    kcLoading: true,
    kcError: null,
    changeEmailSsoError: null
  }),

  [GET_KC_USER_SUCCESS]: (state, action) => ({
    ...state,
    kcUser: action.payload,
    kcError: null,
    emailModalStatus: action.payload?.emailVerified === true
      ? "ready_to_pay"
      : "waiting_verification",
  }),

  [GET_KC_USER_ERROR]: (state, action) => ({
    ...state,
    kcError: action.payload,
    kcUser: null,
    emailModalStatus: "waiting_verification",
  }),

  [GET_KC_USER_FINALLY]: (state) => ({
    ...state,
    kcLoading: false,
  }),

  [SET_KC_USER]: (state, action) => ({
    ...state,
    kcUserExists: action.payload.exists,
    kcUserHasSubscription: action.payload.hasSubscription
  }),

  [CHANGE_EMAIL_SSO_START]: (state) => ({
    ...state,
    changeEmailSsoLoading: true,
    changeEmailSsoError: null,
    changeEmailSsoStatus: null,
  }),

  [CHANGE_EMAIL_SSO_SUCCESS]: (state) => ({
    ...state,
    changeEmailSsoStatus: true,
  }),

  [CHANGE_EMAIL_SSO_ERROR]: (state, action) => ({
    ...state,
    changeEmailSsoError: action.payload,
    changeEmailSsoStatus: false,
  }),

  [CHANGE_EMAIL_SSO_FINALLY]: (state) => ({
    ...state,
    changeEmailSsoLoading: false,
  }),

  [CLEAR_EMAIL_SSO_ERROR]: (state) => ({
    ...state,
    changeEmailSsoError: null
  }),

  [SET_EMAIL_MODAL_STATUS]: (state, action) => ({
    ...state,
    emailModalStatus: action.payload, // "editing" | "waiting_verification" | "ready_to_pay"
  }),

}, initialState)